import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UserService } from '../Account/user.service';
import { UserGroupRepository } from '../Core-Repositories';

@Injectable({ providedIn: 'root' })
export class UserGroupService {
    constructor(private readonly _userService: UserService,
                private readonly _userGroupRepository: UserGroupRepository) {}

    get(instanceId: number): Promise<any[]> {
        return lastValueFrom(this._userGroupRepository.getAll(instanceId));
    }

    getById(id: number): Promise<any> {
        return lastValueFrom(this._userGroupRepository.getById(id));
    }

    getForMember(userGuid: string) : Promise<Weissman.Model.Authentication.UserGroup[]> {
        return lastValueFrom(this._userGroupRepository.getForMember(userGuid));
    }

    getForSetup(contactId: number): Promise<Weissman.Model.Authentication.UserGroup[]> {
        return lastValueFrom(this._userGroupRepository.getForSetup(contactId));
    }

    getList(pageNumber: number, pageSize: number, searchTerm?: number): Promise<any[]> {
        return lastValueFrom(this._userGroupRepository.getList(pageNumber, pageSize, searchTerm));
    }

    update(userGroup, batch): Promise<any> {
        return lastValueFrom(this._userGroupRepository.update(userGroup, batch));
    }

    create(userGroup, batch): Promise<any> {
        return lastValueFrom(this._userGroupRepository.create(userGroup, batch));
    }

    deleteById(id: number): Promise<any> {
        return lastValueFrom(this._userGroupRepository.deleteById(id));
    }

    async isUserInGroup(groupName: string): Promise<boolean> {
        const user = this._userService.getUser();
        const groups = await this.getForMember(user.id);
        return groups.some(x => x.name === groupName);
    }

    isUserSuperUser(): Promise<boolean> {
        return lastValueFrom(this._userGroupRepository.isUserSuperUser());
    }
}
